export const RENDER_STRATEGY = {
  REPLACE_PAGE: 'replace_page',
  REPLACE_COMPONENT: 'replace_component',
  APPEND_TO_CHAT: 'append_to_chat'
};

/**
 * Apply render strategy to the instructions
 * @param {object[]} prev - Previous instructions
 * @param {object} next - Next instruction
 * @returns {object[]} Updated instructions
 */
export function applyRenderStrategy(prev, next) {
  const strategy = next.meta?.renderStrategy || RENDER_STRATEGY.APPEND_TO_CHAT;

  if (strategy === RENDER_STRATEGY.REPLACE_PAGE) {
    return [next];
  }

  if (strategy === RENDER_STRATEGY.REPLACE_COMPONENT) {
    const updated = [...prev];
    const replacement = {
      ...next,
      renderKey: `${next.id}-${Date.now()}` // ensure animation is triggered
      // replacementGroupId: Date.now() // used to ensure only one visible at a time
    };

    if (updated.length > 0) {
      updated[updated.length - 1] = replacement;
      return updated;
    }

    return [replacement];
  }

  return [...prev, next]; // append_to_chat
}
